'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Undo = function Undo(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 16 15' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M.666 6.31l2.565 2.584V5.885C3.231 2.64 5.922 0 9.231 0s6 2.641 6 5.887v8.782h-1V5.886c0-2.649-2.29-4.887-5-4.887-2.711 0-5 2.238-5 4.887v3.007L6.968 6.31l.741.716-3.828 3.751L0 7.027l.666-.717z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Undo;
//# sourceMappingURL=Undo.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Undo.js